export const trustedBy = {
  header: "Trusted By",
  paragraph: "We are trusted by some of the world’s leading organizations",
  images: [
    {
      title: "img0",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img1",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img2",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img3",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img4",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img5",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img6",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img7",
      image: "https://placekitten.com/640/360",
    },
  ],
};

export const feature = {
  header: "Feature In",
  paragraph:
    "NaTakkalam has been featured in leading media publications around the world.",
  images: [
    {
      title: "img0",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img1",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img2",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img3",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img4",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img5",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img6",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img7",
      image: "https://placekitten.com/640/360",
    },
  ],
};
